import { render } from "./Accounting.vue?vue&type=template&id=fc1a28bc&scoped=true"
import script from "./Accounting.vue?vue&type=script&lang=js"
export * from "./Accounting.vue?vue&type=script&lang=js"

import "./Accounting.vue?vue&type=style&index=0&id=fc1a28bc&scoped=true&lang=css"

import exportComponent from "C:\\Users\\khale\\Cookies BIS\\Core-Abudari\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fc1a28bc"]])

export default __exports__